import AuthService from '../services/auth.service';
const DEBUG=false;

const getUserFromLS = () => {
try{ return JSON.parse(localStorage.getItem('user'));
} catch (err){
    localStorage.removeItem('user');
    return null; // if somebody manually changes json in localStorage then destroy record
}};

const user = getUserFromLS();
const initialState = user
  ? { status: { loggedIn: true  }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: { 
    ...initialState,
    servisList: ['UNKNOWN'],
    selectedServis: '',
    company: ''
  },
  getters: {
    currentUser(state) { return state.user;  },
    isLoggedIn(state)  { return state.status?.loggedIn; },
    selectedServis(state) { return state.selectedServis; }
  },
  actions: {
    login({ commit, state }, user) {
      return AuthService.login(user)
      .then(
        user => {
          console.log('store received', user);
          commit('loginSuccess', user);
          if(state.user?.servis_id){
              const row = state.servisList.filter(x=>x.servis_id==state.user?.servis_id)[0];
              commit('setSelectedServis', structuredClone({...row}));
          }
          return Promise.resolve(user);
        },
        error => {
          console.log('store error received', error);
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    setServisList({commit}, company){
      if(DEBUG) console.debug('setServisList', company);
      commit('setCompany', company);
      return AuthService.getServisList(company)
      .then(
        response => {
          if(DEBUG) console.log('setServisList return', response);
          if(response.success){
            const sl = response.servisList?.length>0 ? response.servisList : [company];
            commit('setServisList', sl);
          }
        },
        error => {
          commit('loginFailure');
          AuthService.logout();
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      if(DEBUG) console.debug('logout start');
      AuthService.logout();
      commit('logout');
      if(DEBUG) console.debug('logout end');
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      );
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    setCompany(state, company){
      state.company = company;
    },
    setSelectedServis(state, servisCode){
      state.selectedServis = servisCode;
    },
    setServisList(state, servisList){
      state.servisList = servisList;
    }
  }
};
